














import Vue from 'vue'
export default Vue.extend({
  methods: {
    onDrop(event: DragEvent) {
      event.preventDefault()
      event.stopPropagation()
      const data = event.dataTransfer
      if (data && data.files.length) {
        this.$emit('input', data.files[0])
      }
    },
    onDragEnter(event: Event) {
      event.preventDefault()
      event.stopPropagation()
    },
    onDragOver(event: Event) {
      event.preventDefault()
      event.stopPropagation()
    },
    onDragLeave(event: Event) {
      event.preventDefault()
      event.stopPropagation()
    },
  },
})
